<template>
  <div class="flex cards flex-between">
    <div class="card flex" v-for="(service, index) in services" :key="index">

      <img :src="service.image" :alt="service.title">
      <div class="content">
        <h4>{{ service.title }}</h4>
        <p v-if="service.lead_copy">{{ service.lead_copy }}</p>
      </div>
        <div class="card-link">
            <a href="#" @click.prevent="toggleModal(index)">Read More</a>
        </div>
    </div>

    <portal v-if="showingModal" to="modal">
        <app-modal @close="toggleModal" class="history">
          <div class="flex flex-start">
            <img :src="service.image" :alt="service.title">
            <div class="description">
                <h4>{{ service.title }}</h4>
                <div class="wysiwyg" v-html="service.content"></div>
                <div class="bottom">
                    <a :href="service.url" class="button contact">Contact</a>
                </div>
            </div>
          </div>
        </app-modal>
      </portal>
  </div>
</template>
<script>
export default {
  props: {
    services: Array
  },
  data () {
    return {
      showingModal: false,
      service: {
          title: '',
          image: '',
          content: '',
          url: ''
      }
    }
  },

  methods: {
    toggleModal (index) {

        if (index !== null) {
            this.showingModal = ! this.showingModal
            this.service.title = this.services[index].title
            this.service.image = this.services[index].image
            this.service.content = this.services[index].content
            this.service.url = '/contact?title=' + this.services[index].title
                                + '&reason=Housing Enquiry'
        }

        document.body.style.overflow = "hidden";
    },
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/ServiceCard.vue